import React from "react";

const Chat = React.lazy(() => import("apps/chat/chat-controller"));

const LazyChatController = props => {
  // no fallback b/c weird for user to see spinner here
  return (
    <React.Suspense fallback={<div />}>
      <Chat {...props} />
    </React.Suspense>
  );
};
export default LazyChatController;
